import { DropDownSelector, ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from "../ModalComponent/ModalComponent";
import './ModalContentTransfer.scss'

const ModalContentTransfer = ({
    state,
    setShowModal,
    targetApiData,
    setSelectTargetApi,
    transferApi,
    checkedProducts,
    filterValue,
    setIsModalActive,
    setShowModalDone }) => {

    return (
        <ModalComponent
            title="Перенос товаров"
            onClose={() => setShowModal(false)}
            style={{
                maxWidth: '500px',
                height: 'auto',
                overflow: 'visible'
            }}
            styleContent={{
                overflow: 'visible'
            }}
            child={
                <div className='modal-content-transfer'>

                    <DropDownSelector
                        state={state}
                        options_prop={targetApiData}
                        setState={e => setSelectTargetApi(e)}
                        placeholder='Выберите магазин'
                        width='100%'
                        maxWidth='100%'
                        preventMenuUpward
                    />

                    <div className='counter-product'>
                        <p className='text'>{`${checkedProducts?.length ? checkedProducts?.length : filterValue?.length ? filterValue?.length : 0} товаров`}</p>
                    </div>

                    <div className='btn-group'>
                        <ButtonBasic
                            lilac
                            text='Подключить аккаунт'
                            width='calc(50% - 6px)'
                            onClick={e => setIsModalActive(true)}
                        />
                        <ButtonBasic
                            violet
                            text='Перенести'
                            width='calc(50% - 6px)'
                            onClick={e => {
                                transferApi()
                                setShowModal(false)
                                setShowModalDone(true)
                            }}
                        />
                    </div>
                </div>}
        />
    )
}

export { ModalContentTransfer }